// extracted by mini-css-extract-plugin
export default {"orderShowWrapper":"style_orderShowWrapper__1EOER","order":"style_order__FqnQW","fly":"style_fly__dmxAs","cafe":"style_cafe__kXsrA"};